import { Tab, Tabs } from 'symbiosis-uikit'
import { Link, matchPath, useLocation } from 'react-router-dom'
import { CONFIG } from '~/lib/config'
import styles from './HeaderTabs.pcss'

function useRouteMatch(patterns) {
	const { pathname } = useLocation()

	for (let i = 0; i < patterns.length; i += 1) {
		const pattern = patterns[i]
		const possibleMatch = matchPath(pattern, pathname)
		if (possibleMatch !== null) {
			return possibleMatch
		}
	}

	return null
}

function HeaderTabs() {
	const routeMatch = useRouteMatch([
		'/crosschain-farm',
		'/crosschain-farm-v2',
		'/lp-farm/:earnTypePath/:page',
		'/vesis/*',
		'/claim-rewards',
	])
	const currentTab = routeMatch?.pattern?.path

	return (
		<Tabs value={currentTab} className={styles.tabsContainer}>
			<Tab
				as={Link}
				target="_blank"
				value="sis-staking"
				className={styles.tab}
				to="https://staking.symbiosis.finance"
			>
				<span className={styles.new}>new</span>
				Stake SIS
			</Tab>
			<Tab
				as={Link}
				value="/vesis/*"
				to={`/vesis/${CONFIG.vesis[0].slug}`}
			>
				SIS DAO
			</Tab>

			<Tab as={Link} value="/crosschain-farm-v2" to="/crosschain-farm-v2">
				Farm
			</Tab>
			<Tab
				as={Link}
				value="/lp-farm/:earnTypePath/:page"
				to="/lp-farm/:earnTypePath/:page"
			>
				LP Farm
			</Tab>
			<Tab
				as={Link}
				value="/sis-vault"
				target="_blank"
				to="https://app.symbiotic.fi/vault/0x2eE8fe221AFD5Da36a5cfD4fee12BE5dAb562397"
			>
				SIS Vault
			</Tab>
			<Tab as={Link} value="/claim-rewards" to="/claim-rewards">
				Claim
			</Tab>
		</Tabs>
	)
}

export default HeaderTabs
